import React, { useState, useEffect, useRef } from "react";
import useFetchPost from "../hooks/useFetchPost";

const Subscription = ({ data, setApiRun }) => {
	const [url, setUrl] = useState("");
	const { fetchPostData } = useFetchPost();
	const inputRef = useRef(null);

	const handleClose = () => {
		const subscriptionModal = document.getElementById("subscriptionModal");
		subscriptionModal.classList.remove("show");
		subscriptionModal.style.display = "none";
	};

	const getData = async (data) => {
		const postData = {
			studio_id: data && data.customer_id,
			user_id: data && data.customer_user_uuid,
		};

		let crmStagingUrl = process.env.REACT_APP_CRM + "/classic/customer-details";
		let responseData;
		try {
			responseData = await fetchPostData(crmStagingUrl, postData);
			//console.log("Response:", responseData);
		} catch (error) {
			console.error("Error:", error);
		}

		if (responseData) {
			setUrl(responseData.studio_id.uniqid);
		} else {
			console.warn("Something went wrong in  Subscription Link");
		}
	};
	useEffect(() => {
		if (data && data.customer_id) {
			getData(data);
		}
	}, [data && data.customer_id]);

	const copy = () => {
		const input = document.getElementById("inputLink");
		// Check if the input element exists
		if (!input) {
			console.error("Input element not found");
			return;
		}
		// Select the input text
		input.select();
		try {
			// Copy the selected text to the clipboard
			document.execCommand("copy");
			//console.log("Text copied:", input.value);
		} catch (err) {
			console.error("Unable to copy text:", err);
		}
	};

	return (
		<div
			className="modal fade"
			id="subscriptionModal"
			tabindex="-1"
			role="dialog"
			aria-labelledby="subscriptionModalLabel"
		>
			<div className="modal-dialog" role="document">
				<div className="modal-content">
					<div className="modal-header">
						<button
							type="button"
							className="close"
							data-dismiss="modal"
							aria-label="Close"
							onClick={handleClose}
						>
							<span aria-hidden="true">&times;</span>
						</button>
						<h4 className="modal-title" id="subscriptionModalLabel">
							Copy Subscription Link
						</h4>
					</div>
					<div className="modal-body">
						<form>
							<div class="form-group">
								<input
									type="text"
									className="form-control"
									id="inputLink"
									ref={inputRef}
									value={`https://www.muvi.com/signup/purchaseSubscription.html?studio=${url}`}
								/>
							</div>
						</form>
					</div>
					<div className="modal-footer">
						<button type="button" className="btn btn-blue" data-dismiss="modal" onClick={handleClose}>
							Close
						</button>
						<button type="button" className="btn btn-primary" id="copyButton" onClick={copy}>
							Copy
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Subscription;



// WEBPACK FOOTER //
// ./src/components/crm/modals/Subscription.jsx